import { LazyQueue } from 'scripts/components/lazy/lazyLoadComponent';

const LAZY_LOAD_PRIORITY = 3;

export function preloadAsset(worker: () => (Promise<void> | void), prio = LAZY_LOAD_PRIORITY) {
    LazyQueue.enqueue(worker, prio);
}
